import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TransactionWrapper } from '@core/models';
import { catchError, forkJoin, map, of } from 'rxjs';
import { ConnectionService } from '../services/connection.service';

export const checkoutResolver: ResolveFn<TransactionWrapper | null> = route => {
  const configurationService = inject(ConnectionService);

  configurationService.token = route.queryParams['token'];
  const transactionId = route.params['id'];
  if (!transactionId || !Number.isFinite(Number(transactionId))) {
    return of(null);
  }

  return forkJoin({
    transaction: configurationService.getTransactionById(transactionId, true),
    client: configurationService
      .getCurrentClient()
      .pipe(catchError(() => of(undefined))),
  }).pipe(
    map(({ transaction, client }) => {
      if (!transaction.data) {
        return null;
      }
      return {
        ...transaction.data,
        client: client?.data,
      };
    }),
    catchError(() => {
      return of(null);
    })
  );
};
